import { ConfigurationServicePlaceholders } from 'aws-sdk/lib/config_service_placeholders'
import { requests } from 'sinon'
import { product } from 'src/state/selectors'
import {
  ICoordinates,
  ILocationStopV2,
  ILocationV2,
  IRiderTrip,
  IRiderWithServiceNotification,
  ITripRequestObject,
  ITripRequestState
} from '../../../types'
import { ITripAction } from '../../actions/trips'
import * as constants from '../../constants/'
import moment from 'moment'

const tempLoc = {
  fullAddress: '',
  latitude: 0,
  longitude: 0
}

const initialRequestState: ITripRequestObject = {
  organizationId: '',
  product: {
    productId: '',
    name: ''
  },
  service: {
    serviceId: '',
    name: ''
  },
  routePolyline: '',
  bounds: {},
  pickupLocation: tempLoc,
  dropoffLocation: tempLoc,
  additionalStop: [],
  tripType: 'app',
  details: {},
  passengerDetails: {
    tripRequestRiders: [{ riderType: 'Adult', fareType: 'Cash', totalRider: 1, amount: 0, totalAmount: 0 }],
    disabilityApproved: false,
    attendant: false
  },
  additionalRiders: 1,
  totalRidersFare: 0,
  tripRequester: '',
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  scheduledPickupTime: moment().toISOString()
}

const initialTripRequestState: ITripRequestState = {
  request: initialRequestState,
  settings: {
    productPricing: {
      '1': {
        productId: '1',
        cost: 0,
        fare: 0
      }
    },
    rider: '',
    riderId: '',
    query: '',
    pickupAutoComplete: [],
    dropoffAutoComplete: [],
    additionalStopAutoComplete: [],
    userTrips: [],
    availableProducts: [],
    activeTrips: [],
    tripsSettings: {
      riders: 1,
      wheelchairs: 0,
      assistance: [],
      date: 12856365
    },
    currentTripRequest: false,
    currentTrip: null,
    currentTripFail: null
  },
  metadata: {
    fetching: false,
    fetchingError: '',
    fetchingSuccess: '',
    processing: false,
    processingError: '',
    processingSuccess: ''
  }
}

export function tripRequest(state: ITripRequestState, action: ITripAction): ITripRequestState {
  if (typeof state === 'undefined') {
    return initialTripRequestState
  }
  const metadata = {
    fetching: false,
    fetchingError: '',
    fetchingSuccess: '',
    processing: false,
    processingError: '',
    processingSuccess: ''
  }
  switch (action.type) {
    case constants.TRIP_CREATE_REQUEST:
    case constants.INTEGRATION_FETCH_REQUEST: {
      const metadata = { ...state.metadata, fetching: true }
      return Object.assign({}, state, {
        metadata
      })
    }
    case constants.TRIP_CREATED_WITH_PCA_RIDER_SUCCESS_MESSAGE: {
      return Object.assign({}, state, {
        success: action.payload
      })
    }
    case constants.INTEGRATION_FETCH_SUCCESS: {
      const metadata = { ...state.metadata, fetching: false, fetchingError: '' }
      const productId = action.payload.id
      const serviceId = action.payload.serviceId
      const integrationElememt = state.settings.availableProducts.findIndex(
        item => item.id === productId && item.serviceId === serviceId
      )
      const availableProducts = state.settings.availableProducts.map(item => item)
      availableProducts[integrationElememt] = action.payload
      const settings = { ...state.settings, availableProducts }
      return Object.assign({}, state, {
        metadata,
        settings
      })
    }
    case constants.TRIP_CREATE_SUCCESS: {
      metadata.fetching = false
      metadata.fetchingError = ''
      //When a trip is created successfully, the request process
      //is over, so we reset the request state
      const request = Object.assign({}, initialRequestState)
      return Object.assign({}, state, {
        request,
        metadata
      })
    }
    case constants.TRIP_CREATE_FAILURE: {
      metadata.fetching = false
      metadata.fetchingError = action.payload
      return Object.assign({}, state, {
        metadata
      })
    }
    case constants.CREATE_TRIP_FAIL: {
      return Object.assign({}, state, {
        errors: action.payload
      })
    }
    case constants.SELECT_ORG_FOR_TRIP: {
      const orgId = action.payload
      const request = Object.assign({}, state.request, {
        organizationId: orgId
      })
      return Object.assign({}, state, {
        request
      })
    }
    case constants.SELECT_RIDER_FOR_TRIP: {
      const rider = action.payload
      if (rider) {
        const settings = Object.assign({}, state.settings, { riderId: rider.id })
        const request = Object.assign({}, state.request, {
          rider: {
            email: rider.email,
            riderId: rider.id,
            firstName: rider.firstName || '',
            lastName: rider.lastName || '',
            countryCode: rider.countryCode || '',
            phoneNumber: rider.phone,
            birthDate: rider.birthDate
          }
        })
        return Object.assign({}, state, {
          request,
          settings
        })
      } else {
        return state
      }
    }

    case constants.SELECT_SERVICE_ID: {
      const request = Object.assign({}, state.request, {
        currentServiceId: action.payload
      })
      return Object.assign({}, state, {
        request
      })
    }

    case constants.SELECT_PROVIDER_PRODUCT: {
      const { product } = action.payload
      const url = product.externalUrl
      const iId = product.integrationId
      const pId = product.pricingId
      console.log(`action.payload: ${product.bookingPriority}`)
      const request = Object.assign({}, state.request, {
        service: {
          serviceId: product.serviceId,
          name: product.serviceName
        },
        product: {
          externalUrl: url && url.length ? url : undefined,
          shouldDispatch: url && url.length ? false : true,
          integrationId: iId && iId.length ? iId : undefined,
          pricingId: pId && pId.length ? pId : undefined,
          productId: product.id,
          name: product.name,
          bookingPriority: product.bookingPriority
        }
      })
      return Object.assign({}, state, {
        request
      })
    }
    case constants.RESET_SELECTED_TRIP_REQUEST_PRODUCT: {
      return Object.assign({}, state, {
        request: { ...state.request, product: { productId: '', name: 'a' }, service: { serviceId: '', name: '' } }
      })
    }
    case constants.SEARCH_LOCATION_REQUEST: {
      const settings = Object.assign({}, state.settings, {
        pickupAutoComplete: [],
        dropoffAutoComplete: [],
        additionalStopAutoComplete: []
      })
      metadata.fetching = true
      return Object.assign({}, state, {
        metadata,
        settings
      })
    }
    case constants.USER_TRIPS_REQUEST: {
      const settings = Object.assign({}, state.settings, { userTrips: [] })
      metadata.fetching = true
      return Object.assign({}, state, {
        metadata,
        settings
      })
    }
    case constants.USER_TRIPS_SUCCESS: {
      const settings = Object.assign({}, state.settings, { userTrips: action.payload })
      metadata.fetching = false
      return Object.assign({}, state, {
        metadata,
        settings
      })
    }
    case constants.USER_TRIPS_FAIL: {
      metadata.fetching = true
      metadata.fetchingError = action.payload
      return Object.assign({}, state, {
        metadata
      })
    }
    case constants.CLEAR_AUTO_COMPLETE: {
      const settings = Object.assign({}, state.settings, {
        pickupAutoComplete: [],
        dropoffAutoComplete: [],
        additionalStopAutoComplete: []
      })
      return Object.assign({}, state, {
        settings
      })
    }
    case constants.PICKUP_AUTO_COMPLETE: {
      const settings = Object.assign({}, state.settings, {
        pickupAutoComplete: action.payload
      })
      return Object.assign({}, state, {
        settings
      })
    }
    case constants.DROPOFF_AUTO_COMPLETE: {
      const settings = Object.assign({}, state.settings, {
        dropoffAutoComplete: action.payload
      })
      return Object.assign({}, state, {
        settings
      })
    }
    case constants.ADDITIONAL_STOP_AUTO_COMPLETE: {
      const settings = Object.assign({}, state.settings, {
        additionalStopAutoComplete: action.payload
      })
      return Object.assign({}, state, {
        settings
      })
    }
    case constants.SET_QUERY: {
      const settings = Object.assign({}, state.settings, { query: action.payload })
      return Object.assign({}, state, {
        settings
      })
    }
    case constants.SET_ORIGIN_TO_TRIP_REQUEST: {
      const request = Object.assign({}, state.request)
      const pickupLocation = action.payload
      request.pickupLocation = {
        fullAddress: pickupLocation.formatted_address || '',
        latitude: pickupLocation.lat,
        longitude: pickupLocation.lng,
        notes: pickupLocation.notes,
        placeName: pickupLocation.placeName,
        phoneNumber: pickupLocation.phoneNumber
      }
      return Object.assign({}, state, { request })
    }
    case constants.SET_DISTANCE_AND_DURATION_TO_TRIP_REQUEST: {
      let request = Object.assign({}, state.request)
      request = { ...request, ...action.payload, estimates: { ...request.estimates, ...action.payload } }
      return Object.assign({}, state, { request })
    }
    case constants.SET_ADDITIONAL_STOP_TO_TRIP_REQUEST: {
      const request = Object.assign({}, state.request)
      const additionalStop = request.additionalStop !== undefined ? request.additionalStop : []
      const { formatted_address: fullAddress, lat: latitude, lng: longitude } = action.payload
      const location = {
        fullAddress,
        coordinates: {
          latitude,
          longitude
        },
        latitude,
        longitude,
        index: action.payload.index,
        notes: action.payload.notes,
        placeName: action.payload.placeName,
        phoneNumber: action.payload.phoneNumber
      }
      const selectedStop = additionalStop.find(stop => stop.index === action.payload.index)

      if (selectedStop !== undefined) {
        const filteredStops = additionalStop.filter(stop => stop.index !== action.payload.index)
        request.additionalStop = [...filteredStops, location].sort((a, b) => a.index - b.index)
        return Object.assign({}, state, { request })
      } else {
        request.additionalStop = [...additionalStop, location].sort((a, b) => a.index - b.index)
        return Object.assign({}, state, { request })
      }
    }
    case constants.REMOVE_ADDITIONAL_STOP_FROM_TRIP_REQUEST: {
      const request = Object.assign({}, state.request)
      const { additionalStop } = request
      const index = action.payload
      const filteredStops = additionalStop.filter(stop => stop.index !== index)

      if (filteredStops !== undefined) {
        request.additionalStop = [...filteredStops].sort((a, b) => (a.index as number) - (b.index as number))
        return Object.assign({}, state, { request })
      }
    }
    case constants.TRIP_CLONE: {
      const destinations = action.payload.destinations !== undefined ? action.payload.destinations : []
      const additionalStop = destinations.map((stop: any, index: number) => {
        return {
          ...stop.location,
          index,
          coordinates: {
            latitude: stop.location.latitude,
            longitude: stop.location.longitude
          }
        }
      })
      return Object.assign({}, state, {
        request: { ...action.payload, ...{ passengerDetails: state.request.passengerDetails }, additionalStop }
      })
    }
    case constants.TRIP_LOCATION_SWAP: {
      const request = Object.assign({}, state.request)
      const pickup = request.pickupLocation
      const dropoff = request.dropoffLocation
      request.pickupLocation = dropoff
      request.dropoffLocation = pickup

      return Object.assign({}, state, { request })
    }
    case constants.CHANGE_ADDITIONAL_STOP_ORDER: {
      const request = Object.assign({}, state.request)

      const additionalStops: ILocationStopV2[] = JSON.parse(JSON.stringify(request.additionalStop))

      const draggedStopIndex = action.payload.draggedIndex

      const draggedOverStopIndex = action.payload.draggedOverIndex

      const oldDraggedOverStop = additionalStops.find(value => value.index === draggedOverStopIndex)
      const oldDraggedStop = additionalStops.find(value => value.index === draggedStopIndex)

      if (oldDraggedOverStop !== undefined && oldDraggedStop !== undefined) {
        const draggedOverStop: ILocationStopV2 = {
          ...oldDraggedStop,
          index: action.payload.draggedOverIndex
        }

        const filteredStops = request.additionalStop.filter(stop => stop.index !== action.payload.draggedIndex)

        const filteredUpdatedStops = filteredStops.map(stop => {
          if (draggedStopIndex !== undefined) {
            if (draggedOverStopIndex < draggedStopIndex) {
              if (stop.index !== undefined && stop.index >= draggedOverStopIndex && stop.index < draggedStopIndex) {
                const newStop = {
                  ...stop,
                  index: stop.index + 1
                }

                return newStop
              }
            } else if (draggedOverStopIndex > draggedStopIndex) {
              if (stop.index !== undefined && stop.index <= draggedOverStopIndex && stop.index > draggedStopIndex) {
                const newStop = {
                  ...stop,
                  index: stop.index - 1
                }

                return newStop
              }
            }
          }
          return stop
        })

        const updatedStops = [...filteredUpdatedStops, draggedOverStop].sort(
          (a, b) => (a.index as number) - (b.index as number)
        )

        request.additionalStop = updatedStops
      }

      return Object.assign({}, state, { request })
    }
    case constants.CHANGE_LOCATIONS_ORDER: {
      const request = Object.assign({}, state.request)

      const draggedStopIndex = action.payload.draggedIndex

      const draggedOverStopIndex = action.payload.draggedOverIndex

      const additionalStops: ILocationStopV2[] = JSON.parse(JSON.stringify(request.additionalStop))

      let oldDraggedOverStop
      let oldDraggedStop

      if (draggedStopIndex === -1) {
        oldDraggedStop = request.pickupLocation

        const newPickup: ILocationV2 = {
          ...additionalStops[0],
          coordinates: {
            type: 'Point',
            coordinates: [additionalStops[0].longitude, additionalStops[0].latitude]
          }
        }

        if (draggedOverStopIndex !== -2) {
          oldDraggedOverStop = additionalStops.find(value => value.index === draggedOverStopIndex)

          if (oldDraggedOverStop !== undefined) {
            const newDraggedOverStop: ILocationStopV2 = {
              ...oldDraggedStop,
              index: oldDraggedOverStop.index,
              coordinates: {
                longitude: oldDraggedStop.longitude,
                latitude: oldDraggedStop.latitude
              }
            }

            const filteredStops = request.additionalStop.filter((stop, index) => index !== 0)

            const filteredUpdatedStops = filteredStops.map(stop => {
              if (draggedStopIndex !== undefined) {
                if (stop.index !== undefined && stop.index <= draggedOverStopIndex) {
                  const newStop = {
                    ...stop,
                    index: stop.index - 1
                  }

                  return newStop
                }
              }
              return stop
            })

            const updatedStops = [...filteredUpdatedStops, newDraggedOverStop].sort(
              (a, b) => (a.index as number) - (b.index as number)
            )

            request.additionalStop = updatedStops
            request.pickupLocation = newPickup
          }
        } else {
          const newDropOff: ILocationV2 = request.pickupLocation
          const newLastElement: ILocationStopV2 = {
            ...request.dropoffLocation,
            index: additionalStops[additionalStops.length - 1].index,
            coordinates: {
              longitude: request.dropoffLocation.longitude,
              latitude: request.dropoffLocation.latitude
            }
          }

          const filteredStops = request.additionalStop.filter((stop, index) => index !== 0)

          const filteredUpdatedStops = filteredStops.map(stop => {
            if (stop.index !== undefined) {
              const newStop = {
                ...stop,
                index: stop.index - 1
              }

              return newStop
            } else {
              return stop
            }
          })

          const updatedStops = [...filteredUpdatedStops, newLastElement].sort(
            (a, b) => (a.index as number) - (b.index as number)
          )

          request.additionalStop = updatedStops
          request.dropoffLocation = newDropOff
          request.pickupLocation = newPickup
        }
      } else if (draggedStopIndex === -2) {
        oldDraggedStop = request.dropoffLocation

        const newDropOff: ILocationV2 = {
          ...additionalStops[additionalStops.length - 1],
          coordinates: {
            type: 'Point',
            coordinates: [
              additionalStops[additionalStops.length - 1].longitude,
              additionalStops[additionalStops.length - 1].latitude
            ]
          }
        }

        if (draggedOverStopIndex !== -1) {
          oldDraggedOverStop = additionalStops.find(value => value.index === draggedOverStopIndex)

          if (oldDraggedOverStop !== undefined) {
            const newDraggedOverStop: ILocationStopV2 = {
              ...oldDraggedStop,
              index: oldDraggedOverStop.index,
              coordinates: {
                longitude: oldDraggedStop.longitude,
                latitude: oldDraggedStop.latitude
              }
            }

            const filteredStops = request.additionalStop.filter(
              (stop, index) => index !== request.additionalStop.length - 1
            )

            const filteredUpdatedStops = filteredStops.map(stop => {
              if (draggedStopIndex !== undefined) {
                if (stop.index !== undefined && stop.index >= draggedOverStopIndex) {
                  const newStop = {
                    ...stop,
                    index: stop.index + 1
                  }

                  return newStop
                }
              }
              return stop
            })

            const updatedStops = [...filteredUpdatedStops, newDraggedOverStop].sort(
              (a, b) => (a.index as number) - (b.index as number)
            )

            request.additionalStop = updatedStops
            request.dropoffLocation = newDropOff
          }
        } else {
          const newPickup: ILocationV2 = request.dropoffLocation
          const newFirstElement: ILocationStopV2 = {
            ...request.pickupLocation,
            index: additionalStops[0].index,
            coordinates: {
              longitude: request.pickupLocation.longitude,
              latitude: request.pickupLocation.latitude
            }
          }

          const filteredStops = request.additionalStop.filter(
            (stop, index) => index !== request.additionalStop.length - 1
          )

          const filteredUpdatedStops = filteredStops.map(stop => {
            if (stop.index !== undefined) {
              const newStop = {
                ...stop,
                index: stop.index + 1
              }

              return newStop
            } else {
              return stop
            }
          })

          const updatedStops = [...filteredUpdatedStops, newFirstElement].sort(
            (a, b) => (a.index as number) - (b.index as number)
          )

          request.additionalStop = updatedStops
          request.dropoffLocation = newDropOff
          request.pickupLocation = newPickup
        }
      } else {
        if (draggedOverStopIndex === -1) {
          oldDraggedStop = additionalStops.find(value => value.index === draggedStopIndex)

          const oldPickup = request.pickupLocation

          if (oldDraggedStop !== undefined) {
            const newPickup: ILocationV2 = {
              ...oldDraggedStop,
              coordinates: {
                type: 'Point',
                coordinates: [oldDraggedStop.longitude, oldDraggedStop.latitude]
              }
            }

            const newFirstElement: ILocationStopV2 = {
              ...oldPickup,
              index: additionalStops[0].index,
              coordinates: {
                latitude: oldPickup.latitude,
                longitude: oldPickup.longitude
              }
            }

            const filteredStops = request.additionalStop.filter(stop => stop.index !== draggedStopIndex)

            const filteredUpdatedStops = filteredStops.map(stop => {
              if (draggedStopIndex !== undefined) {
                if (stop.index !== undefined && stop.index <= draggedStopIndex) {
                  const newStop = {
                    ...stop,
                    index: stop.index + 1
                  }

                  return newStop
                }
              }
              return stop
            })

            const updatedStops = [...filteredUpdatedStops, newFirstElement].sort(
              (a, b) => (a.index as number) - (b.index as number)
            )

            request.additionalStop = updatedStops
            request.pickupLocation = newPickup
          }
        } else if (draggedOverStopIndex === -2) {
          oldDraggedStop = additionalStops.find(value => value.index === draggedStopIndex)

          const oldDropoff = request.dropoffLocation

          if (oldDraggedStop !== undefined) {
            const newDropoff: ILocationV2 = {
              ...oldDraggedStop,
              coordinates: {
                type: 'Point',
                coordinates: [oldDraggedStop.longitude, oldDraggedStop.latitude]
              }
            }

            const newLastElement: ILocationStopV2 = {
              ...oldDropoff,
              index: additionalStops[additionalStops.length - 1].index,
              coordinates: {
                latitude: oldDropoff.latitude,
                longitude: oldDropoff.longitude
              }
            }

            const filteredStops = request.additionalStop.filter(stop => stop.index !== draggedStopIndex)

            const filteredUpdatedStops = filteredStops.map(stop => {
              if (draggedStopIndex !== undefined) {
                if (stop.index !== undefined && stop.index >= draggedStopIndex) {
                  const newStop = {
                    ...stop,
                    index: stop.index - 1
                  }

                  return newStop
                }
              }
              return stop
            })

            const updatedStops = [...filteredUpdatedStops, newLastElement].sort(
              (a, b) => (a.index as number) - (b.index as number)
            )

            request.additionalStop = updatedStops
            request.dropoffLocation = newDropoff
          }
        }
      }
      return Object.assign({}, state, { request })
    }
    case constants.SET_DESTINATION_TO_TRIP_REQUEST: {
      const request = Object.assign({}, state.request)
      const dropoffLocation = action.payload

      request.dropoffLocation = {
        fullAddress: dropoffLocation.formatted_address || '',
        latitude: dropoffLocation.lat,
        longitude: dropoffLocation.lng,
        notes: dropoffLocation.notes,
        placeName: dropoffLocation.placeName,
        phoneNumber: dropoffLocation.phoneNumber
      }
      return Object.assign({}, state, { request })
    }
    case constants.SET_DROPOFF_PHONE_NUMBER: {
      const request = Object.assign({}, state.request)
      request.dropoffLocation.phoneNumber = action.payload
      return Object.assign({}, state, { request })
    }
    case constants.SET_PICKUP_PHONE_NUMBER: {
      const request = Object.assign({}, state.request)
      request.pickupLocation.phoneNumber = action.payload
      return Object.assign({}, state, { request })
    }
    case constants.SET_ESTIMATES_TO_TRIP_REQUEST: {
      const estimates = { ...state.request.estimates, ...action.payload }
      const request = { ...state.request, estimates }
      return { ...state, request }
    }

    case constants.SET_LEAVE_AT_TIME_TO_TRIP_REQUEST: {
      const request = { ...state.request, leaveAtDateTime: action.payload }
      return { ...state, request }
    }

    case constants.SET_ARRIVE_BY_TIME_TO_TRIP_REQUEST: {
      const request = { ...state.request, arriveByDateTime: action.payload }
      return { ...state, request }
    }

    case constants.SET_PICKUP_TIME_TO_TRIP_REQUEST: {
      const request = { ...state.request, scheduledPickupTime: action.payload }
      return { ...state, request }
    }
    case constants.SET_CRON_TAB_EXP: {
      const request = { ...state.request, crontabExp: action.payload }
      return { ...state, request }
    }
    case constants.SET_RUN_FOREVER: {
      const request = { ...state.request, runForever: action.payload }
      return { ...state, request }
    }
    case constants.SET_TIMES_TO_RECUR: {
      const request = { ...state.request, timesToRecur: action.payload }
      return { ...state, request }
    }
    case constants.SET_DROPOFF_TIME_TO_TRIP_REQUEST: {
      const request = { ...state.request, scheduledDropoffTime: action.payload }
      return { ...state, request }
    }

    case constants.SET_RECURRING_PICK_UP_TIME: {
      const request = { ...state.request, recurringPickupTime: action.payload }
      return { ...state, request }
    }

    case constants.SET_RECURRING_DROP_OFF_TIME: {
      const request = { ...state.request, recurringDropoffTime: action.payload }
      return { ...state, request }
    }

    case constants.SET_TRIP_DOUBLE_CHECKER_ENABLE: {
      const metadata = { ...state.metadata, fetching: false }
      const request = { ...state.request, tripDoubleCheckerEnable: action.payload }
      return Object.assign({}, state, {
        metadata,
        request
      })
    }

    case constants.SET_BOOK_DOUBLE_TRIP: {
      const request = { ...state.request, bookDoubleTrip: action.payload }
      return { ...state, request }
    }

    case constants.TRIP_AVAILABLE_PRODUCTS_REQUEST: {
      const metadata = { ...state.metadata, fetching: true }
      const settings = { ...state.settings }
      settings.availableProducts = []
      return Object.assign({}, state, {
        metadata,
        settings
      })
    }
    case constants.TRIP_AVAILABLE_PRODUCTS_SUCCESS: {
      const metadata = { ...state.metadata, fetching: false }
      const settings = { ...state.settings }
      settings.availableProducts = action.payload
      return Object.assign({}, state, {
        metadata,
        settings
      })
    }
    case constants.TRIP_AVAILABLE_PRODUCTS_FAILURE: {
      const metadata = { ...state.metadata, fetching: false }
      return Object.assign({}, state, { metadata })
    }

    case constants.GET_TRIP_PRODUCT_PRICING_REQUEST: {
      return Object.assign({}, state)
    }
    case constants.GET_TRIP_PRODUCT_PRICING_SUCCESS: {
      const productPricing = action.payload
      const allProductPricing = Object.assign({}, state.settings.productPricing, productPricing)
      const settings = Object.assign({}, state.settings, { productPricing: allProductPricing })
      return Object.assign({}, state, { settings })
    }
    case constants.GET_TRIP_PRODUCT_PRICING_FAIL: {
      return Object.assign({}, state)
    }
    case constants.CLEAR_LOCATION_SEARCH: {
      const request = Object.assign({}, state.request)
      request.pickupLocation = {
        fullAddress: '',
        latitude: 0,
        longitude: 0
      }
      request.dropoffLocation = {
        fullAddress: '',
        latitude: 0,
        longitude: 0
      }
      request.additionalStop = []
      return Object.assign({}, state, { request })
    }

    case constants.TRIP_NOTES_UPDATE: {
      const request = Object.assign({}, state.request, { notes: action.payload })
      return Object.assign({}, state, { request })
    }

    case constants.TRIP_CONFIRMATION_NUMBER_UPDATE: {
      const request = Object.assign({}, state.request, { confirmationNumber: action.payload })
      return Object.assign({}, state, { request })
    }

    case constants.TRIP_PROVIDER_ONE_NUMBER_UPDATE: {
      const request = Object.assign({}, state.request, { providerOneNumber: action.payload })
      return Object.assign({}, state, { request })
    }

    case constants.TRIP_REQUESTER_NAME: {
      const request = Object.assign({}, state.request, { tripRequester: action.payload })
      return Object.assign({}, state, { request })
    }

    //COA
    case constants.TRIP_PAYMENTMODE_UPDATE: {
      const request = Object.assign({}, state.request, { paymentMode: action.payload })
      return Object.assign({}, state, { request })
    }

    case constants.RIDER_COUNT_UPDATE: {
      const request = Object.assign({}, state.request, { additionalRiders: action.payload, riderCount: action.payload })
      return Object.assign({}, state, { request })
    }
    case constants.TRIP_REQ_DETAILS_UPDATE: {
      const request = Object.assign({}, state.request, { details: action.payload })
      return Object.assign({}, state, { request })
    }

    case constants.SET_TRIP_PASSENGER_DETAILS: {
      const request = Object.assign({}, state.request, { passengerDetails: action.payload })
      return Object.assign({}, state, { request })
    }
    case constants.SET_TRIP_REQUEST_TOTAL_RIDERS_FARE: {
      const request = Object.assign({}, state.request, { totalRidersFare: action.payload })
      return Object.assign({}, state, { request })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/trips/request.ts